/**
 * Tenant admin CMS / MCP OAuth step-up helpers (JWT claim adminStepUpUntil).
 */

function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getAdminStepUpUntil(token) {
  const payload = decodeJwtPayload(token);
  const until = payload?.adminStepUpUntil;
  const n = typeof until === 'number' ? until : Number(until);
  return Number.isFinite(n) ? n : null;
}

export function hasValidAdminStepUp(token, nowMs = Date.now()) {
  const until = getAdminStepUpUntil(token);
  return until != null && until > nowMs;
}

export function isAdminStepUpRequiredError(error) {
  const data = error?.response?.data;
  if (!data) return false;
  if (data.error === 'ADMIN_STEP_UP_REQUIRED') return true;
  if (typeof data.message === 'string' && data.message.includes('ADMIN_STEP_UP_REQUIRED')) {
    return true;
  }
  // Nest ForbiddenException sometimes nests message object
  if (data.message && typeof data.message === 'object' && data.message.error === 'ADMIN_STEP_UP_REQUIRED') {
    return true;
  }
  return false;
}

export default {
  decodeJwtPayload,
  getAdminStepUpUntil,
  hasValidAdminStepUp,
  isAdminStepUpRequiredError,
};
